import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin/reembolsos";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user && typeof user === "object") {
      navigate(from, { replace: true });
    }
  }, [user, from, navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      navigate(from, { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen flex flex-col admin-shell">
      <header
        className="w-full"
        style={{ background: "var(--ldr-red)" }}
      >
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-center">
          <Link
            to="/"
            className="text-white font-bold uppercase tracking-[0.16em] text-base"
          >
            Lendas do Rock
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-5 py-12">
        <div className="w-full max-w-md">
          <div className="ldr-card p-8">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-md bg-[#FBEAEA] text-[var(--ldr-red)] mb-5">
              <Lock size={20} />
            </div>
            <h1 className="text-2xl font-bold text-[var(--ldr-text)]">Acesso ao backoffice</h1>
            <p className="mt-2 text-sm text-[var(--ldr-text-muted)]">
              Área privada. Introduza as suas credenciais para continuar.
            </p>

            <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
              <div>
                <label className="ldr-label" htmlFor="l-email">Email</label>
                <input
                  id="l-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="ldr-input"
                  autoComplete="email"
                  data-testid="admin-login-email"
                />
              </div>
              <div>
                <label className="ldr-label" htmlFor="l-pass">Password</label>
                <input
                  id="l-pass"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="ldr-input"
                  autoComplete="current-password"
                  data-testid="admin-login-password"
                />
              </div>

              {error && (
                <div className="text-sm text-[var(--ldr-red)] bg-[#FBEAEA] border border-[#F0CBCC] rounded-md px-4 py-3"
                     data-testid="admin-login-error">
                  {error}
                </div>
              )}

              <button
                type="submit"
                disabled={submitting}
                className="ldr-btn-primary w-full"
                data-testid="admin-login-submit"
              >
                {submitting && <Loader2 size={16} className="animate-spin" />}
                {submitting ? "A entrar…" : "Entrar"}
              </button>
            </form>
          </div>

          <div className="mt-6 text-center text-xs text-[var(--ldr-text-muted)]">
            <Link to="/" className="hover:text-[var(--ldr-red)]">← Voltar ao site</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
